import * as React from 'react';

import BusinessHeader from './BusinessHeader';
import PublicHeader from './PublicHeader';
import AuthActionsBar from './AuthActionsBar';
import LightPanel from './LightPanel';
import PublicFooter from './PublicFooter';
import BusinessSignUp from './BusinessSignUp';

import { isHostBusiness } from '../utils/host';

export const LoginPage = ({ children, ...props }: any) => {
  return (
    <div className="w-100 sans-serif">
      {isHostBusiness() ? <BusinessHeader /> : <PublicHeader />}
      <React.Fragment>
        {!isHostBusiness() && <BusinessSignUp />}
        <AuthActionsBar {...props} />
      </React.Fragment>
      <article className="pv5 pa3 pa5-ns animated fadeIn bg-white black mw9 ml-auto mr-auto">
        <div className="features list cf ma0 pa0">
          <LightPanel
            className="dn db-l"
            image_url="/images/guided.jpg"
            title="Become part of Filtru"
            subtitle="Get your brand in front of coffee aficionados."
          />
          <div className="fl w-100 w-50-l pr1-ns pr2-l pb3 pb2-l">
            <div className="aspect-ratio aspect-ratio--1x1 bg-ui-white-0">
              <div className="aspect-ratio--object cover z-1" />

              <div
                className="absolute
              absolute--fill flex items-center justify-center flex-column z-2"
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </article>
      <PublicFooter />
    </div>
  );
};

export default LoginPage;
